import { useEffect } from 'react';

// Dynamically loads a Google Font so the branding typography actually renders
// (mirrors the designer's CustomizationContext font loader). Without this the
// picked font silently falls back to sans-serif. The <link> is injected once
// per font (id-guarded) and kept for the session — fonts are tiny and cached.
export function useGoogleFont(font: string | undefined) {
  useEffect(() => {
    if (!font) return;
    const id = `google-font-${font.replace(/\s+/g, '-').toLowerCase()}`;
    if (document.getElementById(id)) return;

    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${font.replace(/\s+/g, '+')}:wght@300;400;500;600;700;800&display=swap`;
    document.head.appendChild(link);
  }, [font]);
}
